import template from './mouvement.html'
import css from './mouvement.css'
import { MouvementController } from './mouvement.controller.js'

export const MouvementComponent = {
  template: template,
  controller: MouvementController,
  controllerAs: 'MouvementController',
  require:{
  	parentSimulator: '^^simulatorComponent'
  },
  bindings: {
    resource: '='
  }
}



// WEBPACK FOOTER //
// ./src/client/pages/simulator/components/mouvement/mouvement.component.js